module.exports = __webpack_public_path__ + "img/logo.24d3af81.svg";